<template>
  <div
    v-if="modelValue"
    class="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
    @click.self="cancel"
    @keydown.esc="cancel"
    tabindex="0"
    role="dialog"
    aria-modal="true"
    aria-labelledby="delete-title"
  >
    <div class="bg-white rounded-[28px] w-full max-w-lg shadow-xl p-8 sm:p-10">
      <div class="mx-auto mb-6 w-16 h-16 rounded-full bg-red-500 grid place-items-center shadow-md">
        <svg viewBox="0 0 24 24" class="w-7 h-7 text-white">
          <path
            fill="currentColor"
            d="M18.3 5.71 12 12l6.3 6.29-1.41 1.42L10.59 13.4 4.3 19.71 2.89 18.3 9.17 12 2.89 5.71 4.3 4.29 10.59 10.6 16.89 4.29z"
          />
        </svg>
      </div>

      <h2 id="delete-title" class="text-center text-lg sm:text-[15px] font-bold text-gray-900 mb-2">
        {{ title }}
      </h2>
      <p class="text-center text-lg sm:text-[15px] font-bold text-gray-900">
        {{ message }}
      </p>

      <div class="mt-8 flex items-center justify-between">
        <button
          type="button"
          class="h-10 px-6 rounded-full border border-gray-300 bg-white text-gray-700 shadow-sm hover:bg-gray-50"
          @click="cancel"
        >
          Cancel
        </button>
        <button
          type="button"
          class="h-10 px-8 rounded-full text-white shadow-sm hover:opacity-95"
          :style="{ backgroundColor: '#5B9AC5' }"
          @click="confirm"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeleteModal",
  props: {
    modelValue: { type: Boolean, default: false },
    title: { type: String, default: "Are you sure?" },
    message: { type: String, default: "Delete this item?" },
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  methods: {
    cancel() {
      this.$emit("cancel");
      this.$emit("update:modelValue", false);
    },
    confirm() {
      this.$emit("confirm");
      this.$emit("update:modelValue", false);
    },
  },
};
</script>
